const download = function (filename, response) {
    const file = new Blob([response.data], { 'type': "" });
    const url = window.URL.createObjectURL(file);
    const doc = document.createElement("a");
    document.body.appendChild(doc);
    doc.setAttribute("href", url);
    doc.setAttribute("download", filename);
    doc.style.visibility = "hidden";
    doc.click();
    setTimeout(() => {
        document.body.removeChild(doc);
        window.URL.revokeObjectURL(url);
    }, 200);
};
const clone = (element) => {
    const clone = element.cloneNode(true);
    //@ts-ignore
    const cloneCanvases = clone.getElementsByTagName("canvas");
    const canvases = element.getElementsByTagName("canvas");
    for (let i = 0; i < canvases.length; i++) {
        const classes = canvases[i].classList;
        const img = document.createElement("img");
        classes.forEach((c) => {
            img.classList.add(c);
        });
        img.src = canvases[i].toDataURL();
        cloneCanvases[i].replaceWith(img);
    }
    return clone;
};
const PrintPdf = {
    install(app, options = {}) {
        app.provide("$pdf", {
            get body() {
                return document.body;
            },
            async print(filename, element) {
                element = element || this.body;
                const node = clone(element);
                //@ts-ignore
                const response = await options.Axios.post("/api/v1/reports/print", { html: node.outerHTML }, {
                    headers: {
                        "Content-type": "application/json",
                        "Accept": "application/pdf"
                    },
                    responseType: "arraybuffer"
                });
                download(filename + ".pdf", response);
                return Promise.resolve(response);
            }
        });
    }
};
export default PrintPdf;
